<template>
  <mg-autocomplete
    :fetch-suggestions="fetchSuggestions"
    @select="onSelect"
    :highlight-first-item="true"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #header>
      <slot name="header">
        <template v-for="column in item.columns">
          <span :style="{ width: column.width }" :key="column.prop">{{ column.label }}</span>
        </template>
      </slot>
    </template>
    <template slot-scope="{ item: items }">
      <slot :item="items">
        <template v-for="column in item.columns">
          <span :style="{ width: column.width }" :key="column.prop">
            {{ items[column.prop] }}
          </span>
        </template>
      </slot>
    </template>
  </mg-autocomplete>
</template>

<script>
  export default {
    name: 'FormItemAutocomplete',
    props: {
      item: Object,
    },
    computed: {
      columns() {
        return this.item.columns || []
      },
      queryMethod() {
        return this.item.queryMethod
      },
      searchKey() {
        return this.item.searchKey || 'searchKey'
      },
      valueKey() {
        return this.item.valueKey || 'skuCode'
      },
    },
    methods: {
      onSelect(item) {
        this.$emit('input', item[this.valueKey])
      },
      fetchSuggestions(searchKey, cb) {
        if (searchKey === null || searchKey?.trim().length < (this.$attrs?.limit || 3)) return
        if (this.queryMethod) {
          this.queryMethod({ [this.searchKey]: searchKey })
            .then((res) => {
              cb(res.data)
            })
            .catch(() => {
              cb([])
            })
        }
      },
    },
  }
</script>
